/**
 * Подтип заказа из настроек колл-центра (call_center_order_types).
 * @param {object} callCenter — reduxAccount.call_center
 * @param {number} orderTypeId — 1 hall / 2 takeaway / 3 delivery
 */
export function resolveCallCenterOrderTypeSubId(callCenter, orderTypeId) {
	const typeId = Number(orderTypeId)
	const types = callCenter?.order_types || []
	const row = types.find((item) => (
		Number(item.order_type_id ?? item.id) === typeId
	))
	if (row?.order_type_sub_id != null && row.order_type_sub_id !== '') {
		return Number(row.order_type_sub_id)
	}
	if (callCenter?.order_type_sub_id != null && callCenter.order_type_sub_id !== '') {
		return Number(callCenter.order_type_sub_id)
	}
	return null
}
